module.exports = __webpack_public_path__ + "static/img/doe1205.52a995e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo_sur/doe1205.png
// module id = CpNo
// module chunks = 0